@import '../../utils/interaction-fill.css';
@import '../../utils/control-inactive.css';
@import '../../utils/control-density.css';
@import '../../utils/control-parts.css';
@import '../../utils/control-width.css';
@import '../../utils/field-stack.css';
@import '../../utils/typography.css';
@import '../../utils/forced-colors.css';

:host(.input-host) {
  display: inline-flex;
  --ds-input-fg: var(--color-foreground-primary);
  --ds-input-placeholder: var(--color-foreground-secondary);
  --ds-input-placeholder-active: var(--color-foreground-quaternary);
  --ds-input-adornment-fg: var(--color-foreground-secondary);
  --ds-input-border: var(--color-border-secondary);
}

:host(.ds-control-width--fill),
:host(.ds-control-width--fill) .input-control {
  width: 100%;
}

.input-control {
  overflow: hidden;
  background: transparent;
  border: none;
  border-radius: var(--ds-control-radius, var(--dimension-radius-025));
  color: var(--ds-input-fg);
}

.input-control--bordered {
  --ds-interaction-border-width: var(--dimension-stroke-width-012);
  --ds-interaction-border-color: var(--ds-input-border);
}

.input-control--error {
  --ds-interaction-border-width: var(--dimension-stroke-width-018);
  --ds-interaction-border-color: var(--color-border-bold-negative);
}

.input-control--bordered:focus-within:not(.input-control--error) {
  --ds-interaction-border-width: var(--dimension-stroke-width-018);
  --ds-interaction-border-color: var(--color-border-bold-brand);
}

:host(.ds-control-inactive) .input-control::after {
  background: transparent;
}

.native-input {
  position: relative;
  z-index: 2;
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
  background: transparent;
  border: none;
  border-radius: inherit;
  outline: none;
  color: var(--ds-input-fg);
  font-family: inherit;
  -webkit-appearance: none;
  appearance: none;
}

.native-input:disabled {
  cursor: not-allowed;
}

.native-input:read-only:not(:disabled) {
  cursor: default;
}

.native-input::placeholder {
  color: var(--ds-input-placeholder);
}

.native-input:focus::placeholder {
  color: var(--ds-input-placeholder-active);
}

.native-input[type='search']::-webkit-search-cancel-button,
.native-input[type='search']::-webkit-search-decoration {
  display: none;
}

.input-control__prefix,
.input-control__suffix {
  position: relative;
  z-index: 2;
  color: var(--ds-input-adornment-fg);
}

.input-control__suffix--empty {
  display: none;
}

/* Keep this more specific than ButtonUnfilled's host-level hug alignment so
   component stylesheet hydration order cannot move the nested action. */
.input-control > .input-control__clear {
  position: relative;
  z-index: 2;
  flex-shrink: 0;
  align-self: center;
}

.input-control.ds-control--lg:has(.input-control__clear),
.input-control.ds-control--md:has(.input-control__clear),
.input-control.ds-control--sm:has(.input-control__clear) {
  padding-right: var(--dimension-space-050);
}

.input-control.ds-control--xs:has(.input-control__clear) {
  padding-right: 0;
}

.error-text {
  width: 100%;
}

@media (forced-colors: active) {
  .input-control--bordered:focus-within:not(.input-control--error)::after {
    outline-color: var(--ds-forced-color-selected);
  }

  .input-control--error::after {
    outline-style: dashed;
  }
}
